import { Typography as e } from "../../Typography/Typography.mjs";
import { useMobile as t } from "../../hooks/useMobile.mjs";
import { Popup as n } from "../Popup/Popup.mjs";
import { useOutsideClose as r } from "../../hooks/useOutsideClose.mjs";
import { MobileContent as i, Popover as a } from "./styled/TimePanel.styled.mjs";
import { TimePickerPanel as o } from "./components/TimePickerPanel.mjs";
import { ClearBtn as s, Placeholder as c, Root as l, Trigger as u, TriggerInner as d } from "./styled/TimePicker.styled.mjs";
import { useRef as f, useState as p } from "react";
import { useTranslation as m } from "@maat/store-i18n";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
import { Clock as _, X as v } from "lucide-react";
import { formatTimePicker as y } from "@maat/datetime";
//#region src/components/TimePicker/TimePicker.tsx
var b = ({ value: b, onChange: x, placeholder: S, disabled: C, label: w, error: T, className: E, step: D = 5, list: O }) => {
	let { t: k } = m("ds"), { isMobile: A } = t(), [j, M] = p(!1), N = f(null);
	r(N, {
		enabled: !A,
		onClose: () => M(!1)
	});
	let P = S ?? k("ds:timePicker.selectTime");
	return /* @__PURE__ */ g(l, {
		ref: N,
		className: E,
		children: [
			w && /* @__PURE__ */ h(e, {
				variant: "label",
				children: w
			}),
			/* @__PURE__ */ g(u, {
				type: "button",
				$open: j,
				$error: !!T,
				$disabled: C,
				disabled: C,
				onClick: () => M((e) => !e),
				"aria-haspopup": "dialog",
				"aria-expanded": j,
				children: [/* @__PURE__ */ g(d, { children: [/* @__PURE__ */ h(_, {
					size: 15,
					opacity: .6
				}), b ? /* @__PURE__ */ h("span", { children: y(b) }) : /* @__PURE__ */ h(c, { children: P })] }), b && /* @__PURE__ */ h(s, {
					type: "button",
					onClick: (e) => {
						e.stopPropagation(), x?.(null);
					},
					"aria-label": k("common:actions.clear"),
					children: /* @__PURE__ */ h(v, { size: 13 })
				})]
			}),
			A ? /* @__PURE__ */ h(n, {
				open: j,
				onClose: () => M(!1),
				title: w ?? k("ds:timePicker.selectTime"),
				children: /* @__PURE__ */ h(i, { children: /* @__PURE__ */ h(o, {
					value: b,
					step: D,
					list: O,
					onChange: (e) => x?.(e),
					onCommit: () => M(!1)
				}) })
			}) : j && /* @__PURE__ */ h(a, {
				role: "dialog",
				"aria-label": k("ds:timePicker.dialogLabel"),
				children: /* @__PURE__ */ h(o, {
					value: b,
					step: D,
					list: O,
					onChange: (e) => x?.(e),
					onCommit: () => M(!1)
				})
			}),
			T && /* @__PURE__ */ h(e, {
				variant: "caption",
				color: "error",
				children: T
			})
		]
	});
};
//#endregion
export { b as TimePicker };
